import Factory from '../utils/factory'
import Person from '../Person'

export default Factory({
  id: null,
  document: null,
  template: {
    document: null,
    attachments: null,
  },
  data: {
    applicant: Person(),
    hasCoApplicant: false,
    coApplicant: Person(),
    customFields: null,
  },
})
